import React, { ReactNode } from "react";
import { PButtonStyle as S } from "./PButton.style";
import { Button, ButtonProps } from "primereact/button";
import { useClassNames } from "hooks/useClassNames";

export type PButtonProps = Omit<ButtonProps, "size" | "label"> & {
  size?: "tiny" | "small" | "large" | "default" | undefined;
  label?: string | ReactNode;
};

export const PButton = React.forwardRef<Button, PButtonProps>((props, ref) => {
  const { size, label, ...cleanProps } = props;
  const classNames = useClassNames(
    {
      ["p-button-icon-" + props.iconPos]: !!props.iconPos,
      "p-button-tiny": props.size === "tiny",
    },
    props.className,
  );
  return (
    <S.PButton
      type="button"
      {...cleanProps}
      label={label as never}
      size={size !== "default" && size !== "tiny" ? size : undefined}
      rounded={props.rounded === undefined ? true : props.rounded}
      className={classNames}
      ref={ref}
    />
  );
});
